import { IEltCompanyPerformanceItem } from 'legacy/lut/classes/models/partner360/ELT/docEltType/IEltCompanyPerfomance'
import { TComplexSectionData } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { getFormedEltTranslation } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/getFormedEltTranslation'
import { useTableActions } from 'legacy/lut/components/widgets/public/partner360/ELT/hooks/useTableActions'
import { getCompanyPerformanceColumns } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/docContent/step2/components/companyPerformance/helpers/getCompanyPerformanceColumns'
import { StyledTable } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/styledComponents/styledTable/StyledTable'
import { Title } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/styledComponents/title/Title'
import { useMemo } from 'react'

import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

import styles from './CompanyPerformance.module.scss'

interface ICustomerRevenueProps {
  data: IEltCompanyPerformanceItem[]
  netNdpValue: ActualsValueTypes
  updateFormData: (data: TComplexSectionData) => void
  fYear: number
}

const KEY_FIELD = 'TranslationKey'
export const CompanyPerformance = ({
  data,
  updateFormData,
  fYear,
  netNdpValue,
}: ICustomerRevenueProps) => {
  const { onChangeByKey } = useTableActions<IEltCompanyPerformanceItem>({
    updateFormData: updateFormData,
    data: data,
  })

  const columns = useMemo(
    () =>
      getCompanyPerformanceColumns({
        netNdpValue,
        onChange: onChangeByKey(KEY_FIELD),
        currentYear: fYear,
      }),
    [onChangeByKey, fYear, netNdpValue]
  )

  return (
    <div>
      <Title
        variant="withBackground"
        text={getFormedEltTranslation('doc-section-company-performance')}
        translationReplaceParams={[
          {
            key: '{netNdp}',
            value: netNdpValue.toUpperCase(),
          },
        ]}
      />

      <StyledTable<IEltCompanyPerformanceItem>
        columns={columns}
        items={data}
        keyField={KEY_FIELD}
        classes={{ td: styles.shortTdWidth }}
      />
    </div>
  )
}
